import { Variants } from '../types/variant';

export const allergoVariants = {
  allergo: {
    name: 'Allergologie',
    status: 'stable',
    availableInDemo: false,
    description:
      "Questionnaire pour les patients consultant un allergologue. Couvre les motifs, les symptômes immédiats et retardés, les facteurs d'exposition les antécédents personnels et familiaux du patient .",
    speciality: 'ALLERGO',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DEFAULT',
    emailTemplate: 'MED_G_DEFAULT',
    reportTemplate: 'ALLERGO',
    initialQuestions: [],
    initialAssertions: [],
    pages: {
      CONSULTATION: { title: 'Consultation', sections: ['CONTEXTE'] },
      COMPLAINTS: {
        title: 'Motifs',
        sections: [
          'MOTIF',
          'MOTIF_ANAPHYLAXIE',
          'SYMPT_OEDEME',
          'SYMPT_RESPI_ORL',
          'SYMPT_ORL_OPHT_FOLLOWUP',
          'SYMPT_PNEUMO_FOLLOWUP',
          'SYMPT_RESPI_ORL_TRANSVERSAL',
          'SYMPT_CUTANES',
          'REAC_ALIM',
          'TRBL_DIGEST',
          'REAC_MEDIC',
          'PIQ_INSECT',
        ],
      },
      SYMPTOMS: {
        title: 'Autres symptômes',
        sections: [
          'SYMPTÔMES',
          'SYMPTÔMES OPHTALMO',
          'SYMPTÔMES DERMATO',
          'SYMPTÔMES PNEUMO',
          'SYMPTÔMES GASTRO',
          'SIGNES GENERAUX',
          'SYMPTÔMES ORL',
        ],
      },
      FACTORS: {
        title: 'Facteurs favorisants ou déclenchants',
        sections: [
          'ALLERGIES DE CONTACT',
          'PEAU SÈCHE',
          'FACTEURS DÉCLENCHANTS',
          'ALLERGIES ALIMENTAIRES',
        ],
      },
      HISTORY: { title: 'Antécédents', sections: ['ATCD'] },
      TREATMENT: { title: 'Traitements', sections: ['TRAITEMENT'] },
      CONCLUSION: { title: 'Conclusion', sections: ['RECAP'] },
    },
    options: [],
    visitMotivesSection: 'Motif Principal',
  },
} satisfies Variants;
